const groupsStr = {
  toastr: 'Grupo deletado',
  toastr1: 'deletado com sucesso'
};

export default groupsStr;
